/**
 * 自定义字段排序方式
 */
export var CustomFieldSortType;
(function (CustomFieldSortType) {
    /**
     * 最早创建
     */
    CustomFieldSortType["EARLY_CREATED"] = "tasc";
    /**
     * 最新创建
     */
    CustomFieldSortType["LATEST_CREATED"] = "tdesc";
    /**
     * 按名称排序
     */
    CustomFieldSortType["NAME_ASC"] = "nasc";
    /**
     * 自定义顺序
     */
    CustomFieldSortType["CUSTOM"] = "custom";
})(CustomFieldSortType || (CustomFieldSortType = {}));
